/* eslint-disable
    func-names,
    max-len,
    no-param-reassign,
*/
/**
 * Accesses bench services APIs. Will redirect to the login screen on failed requests.
 */
const factory = function (
  $http,
  $window,
  $rootScope,
  $q,
  url,
  path,
  AuthActions,
  benchLocation,
  TimeoutWarningService,
) {
  $http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  const apiRoot = benchLocation.apiRoot();
  const bookkeepingApiRoot = benchLocation.bookkeepingApiRoot();

  const apiPaths = {
    main: '/api/v1/',
    reports: '/reports/api/',
    gateway: '/gateway/web/api/',
    fds: '/financial-data/api/',
    categorizer: '/categorizer/api/',
    benchBackend: '',
    base: '',
  };

  class Api {
    constructor(apiName = 'main') {
      this.apiName = apiName;
      this.apiPath = apiPaths[this.apiName];
      this.rootUrl =
        this.rootUrl || this.apiName === 'benchBackend'
          ? bookkeepingApiRoot
          : url.resolve(apiRoot, this.apiPath);
    }

    request(httpConfig) {
      // a local running version of benchception (ie. not mydevbox) cannot access the serverless bookkeeping API
      if ($window.location.href.includes('nginx.service.bench') && this.apiName === 'benchBackend')
        throw 'bench-backend Bookkeeping API can only be accessed for development via mydevbox';

      return $http(
        angular.extend(
          {},
          httpConfig,
          {
            url: url.resolve(this.rootUrl, httpConfig.url),
            withCredentials: true,
          },
          TimeoutWarningService.$resetTimer(),
        ),
      ).catch(res => {
        if ([401, 403].includes(res.status)) {
          window.dispatchEvent(
            new CustomEvent(AuthActions.authenticate(), { detail: { reload: true } }),
          );
        }
        return $q.reject(res);
      });
    }

    href(to) {
      return url.resolve(apiRoot, path.join(this.apiPath, to));
    }

    navigate(to) {
      return ($window.location.href = this.href(to));
    }
  }

  return Api;
};

module.exports = factory;
